var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-tag',{staticStyle:{"min-width":"728px","min-height":"90px"},attrs:{"gpt-id":"div-gpt-ad-1708519721344-0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }